<template>
  <transition name="slide-fade">
    <v-container fluid class="register">
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center">Create Account</h3>
        </v-flex>
        <v-flex xs12 sm11 md6>
          <v-card>
            <v-card-text>
              <register-client :errors="errors"></register-client>
            </v-card-text>
            <v-card-actions>
              <v-btn text small href="/privacy-policy">Privacy Policy</v-btn>
              <v-btn text small href="/terms-of-use">Terms Of Use</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/Guest'
  const RegisterClient =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "guest" */ '@/Pages/Auth/Client')

  export default {
    name: 'CreateClientAccount',
    layout,
    props: [
      'errors'
    ],
    components: {
      RegisterClient,
    },
    metaInfo () {
      return {
        title: 'Join as a patient',
        titleTemplate: '%s | ' + this.$title,
      }
    },
  }
</script>

<style>
  .register {
    background: url('/images/tablets.jpg');
    background-attachment: fixed;
    background-size: cover;
  }
</style>
